import { styled } from '@mui/system'
import { uniqueId, noop } from 'es-toolkit/compat'
import useMap from 'hooks/use-map'
import { defaultBackground, defaultShadow } from 'components/foundation'
import React, { useEffect, useState } from 'react'

/**
 * Create a Map.
 *
 * @param {object}   props
 * @param {string}   props.id      An identifier for the map. If none is provided one will get genereted. In either case
 *                                 the id will be available on props.onReady function.
 * @param {function} props.onReady When component is rendered and ready this function will run with the map's id as an argument.
 */
const OLMap = React.forwardRef(
  ({ id: idProp, onReady = noop, children }, ref) => {
    const [id, setId] = useState(idProp)

    const map = useMap()

    useEffect(() => {
      if (map) {
        map.setTarget(ref.current)
        setId(uniqueId('map-'))
      }
    }, [map])

    useEffect(() => {
      if (id) {
        onReady(id)
      }
    }, [id])

    return (
      <StyledWrapper>
        <StyledMap id={id} ref={ref}>
          {children}
        </StyledMap>
      </StyledWrapper>
    )
  },
)

OLMap.displayName = 'OpenLayersMap'

export default OLMap

const StyledWrapper = styled('div')({
  height: '100%',
  ...defaultBackground,
  ...defaultShadow,
})

const StyledMap = styled('div')({
  height: '100%',
  width: '100%',
  position: 'relative',
})
